$w.onReady(function () {
	EnableButtons();
});

function EnableButtons() {
	$w('#buttonLawEnforcement').enable();
	$w('#buttonResources').enable();
	$w('#buttonMedia').enable();
	$w('#buttonCompany').enable();
}